import React, { PropsWithChildren, ReactNode } from 'react';

import SubtitleRegular from 'components/Typography/SubtitleRegular';

import './index.scss';

export interface CardProps {
  title?: string;
  actions?: ReactNode;
  className?: string;
}

export default function Card({
  title, actions, className = '', children,
}: PropsWithChildren<CardProps>) {
  const hasHeader = Boolean(title) || Boolean(actions);

  return (
    <div className={`ds-card ${className}`.trim()}>
      {hasHeader && (
        <div className="ds-card__header">
          {title && <SubtitleRegular>{title}</SubtitleRegular>}
          {actions && <div className="ds-card__actions">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
